import React from "react";

export default function Maintenance() {
  return (
    <div className="container-fluid vh-100 d-flex justify-content-center align-items-center bg-light">
      <div className="text-center">
        <h1 className="display-4">🚧 Maintenance Mode</h1>
        <p className="lead mt-3">
          Our website is currently under maintenance.
        </p>
        <p>We’re making some improvements. Thanks for your patience!</p>

        <div className="spinner-border text-primary mt-3" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  );
}